import './SingleAudioPlay.scss';
import images from '../../assets/images';
import AudioPlayer from 'react-h5-audio-player';
import 'react-h5-audio-player/src/styles.scss'
import { FC, useCallback, useEffect, useRef, useState } from 'react';
import { materialsData } from '../../utils/interface';
import { isPlatform } from '@ionic/react';
import { Tooltip } from '@mui/material';


interface SingleAudioPlayProps{
  podCastPdfFileData?: materialsData | undefined;
  podCastPDFFilePath?: string
}

const SingleAudioPlay: FC<SingleAudioPlayProps> = ({podCastPdfFileData, podCastPDFFilePath}) => {
  const {playIcon, podcastDefaultImage, pauseIcon, forwardIcon, rewindIcon,volumeDownIcon, volumeUpIcon} = images;
  const baseUrl = process.env.REACT_APP_FRONTEND_URL;
  const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);

  const textRef = useRef<HTMLDivElement>(null);
  const [isEllipsisActive, setIsEllipsisActive] = useState(false);

  const checkEllipsis = useCallback(() => {
    if (textRef.current) {
      setIsEllipsisActive(textRef.current.scrollWidth > textRef.current.clientWidth);
    }
  }, []);

  useEffect(() => {
    checkEllipsis();
    window.addEventListener("resize", checkEllipsis);
    return () => window.removeEventListener("resize", checkEllipsis);
  }, [checkEllipsis, podCastPdfFileData?.filename]);

  
  return (
    <div className='SingleAudioPlayMainContainer'>
        <div className='topSectionStyle'>
          <div className='podcastImageContainer'>
              <div className='titleStyle'>{`Listening to`}</div>
              <div className='ImageContainer'>
                <img src={podCastPdfFileData?.coverImagePath ? baseUrl+podCastPdfFileData?.coverImagePath : podcastDefaultImage} alt="coverImage" className='coverImageStyle'/>
              </div>
          </div>
          <div className='poweredByContainer'>
          <Tooltip title={isEllipsisActive ? podCastPdfFileData?.filename : ""} arrow>
      <div
        ref={textRef}
        className="podcastTitle"
      >
        {podCastPdfFileData?.filename}
      </div>
    </Tooltip>
              <div className='poweredByText'>{`Podcast produced by Katon Network`}</div>
          </div>
        </div>
        <AudioPlayer
            autoPlay
            // src={isPlatform('android') ? (podCastPDFFilePath ? podCastPDFFilePath : podCastPdfFileData?.filepath && baseUrl+podCastPdfFileData?.filepath) : podCastPdfFileData?.filepath ? baseUrl+podCastPdfFileData?.filepath : ''}
            className={isIOS ? 'hide-controls' : ''}
            src={podCastPDFFilePath ? podCastPDFFilePath : podCastPdfFileData?.filepath && baseUrl+podCastPdfFileData?.filepath} 
            customIcons={{
                play: <img src={playIcon} style={{width: '25px', height: '25px', objectFit: 'cover'}} alt='playIcon'/>,
                pause: <img src={pauseIcon} style={{width: '25px', height: '25px', objectFit: 'cover'}} alt='pauseIcon'/>,
                rewind: <img src={rewindIcon} alt='rewindIcon'/>,
                forward: <img src={forwardIcon} alt='forwardIcon'/>,
                volume: <img src={volumeUpIcon} style={{width: '32px', height: '32px'}} alt='volumeUpIcon'/>,
                volumeMute: <img src={volumeDownIcon} style={{width: '32px', height: '32px'}} alt='volumeDownIcon'/>
            }}
            customAdditionalControls={[]} // used to hide the loop mode
            customVolumeControls={isIOS ? [] : undefined} // used to hide the volume control
        />
    </div>
  )
}

export default SingleAudioPlay
